import { useEffect, useState } from "react";
import styled from "styled-components";

import * as UI from "../../../../../../modules/ui-kit";
import ProductSelector from "../../entities/product/ProductSelector";
import Properties from "../Properties";
import UnitOfMeasurementSelect from "./UnitOfMeasurementSelect";
import useComponentType from "./useComponentType";

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export default function ComponentDetail(props) {
    const {
        bimClassID,
        componentTypeID,
        onChange,
        onClose,
        product,
        properties,
        quantity,
        unitOfMeasurement,
    } = props;

    const componentType = useComponentType(componentTypeID, bimClassID);

    const [updatedProduct, setProduct] = useState(undefined);
    useEffect(
        () => setProduct(product),
        [product],
    );

    const [updatedQuantity, setQuantity] = useState(undefined);
    useEffect(
        () => setQuantity(quantity),
        [quantity],
    );

    const [updatedUOM, setUOM] = useState(undefined);
    useEffect(
        () => setUOM(unitOfMeasurement),
        [unitOfMeasurement],
    );

    const [updatedProperties, setProperties] = useState(undefined);
    useEffect(
        () => setProperties(properties),
        [properties],
    );

    function onSubmit(event) {
        event.preventDefault();

        const update = {};
        if (updatedProduct !== undefined) update.product = updatedProduct;
        if (updatedQuantity !== undefined) update.quantity = updatedQuantity;
        if (updatedUOM !== undefined) update.unitOfMeasurement = updatedUOM;
        if (updatedProperties !== undefined) update.properties = updatedProperties;

        onChange(update);
        onClose();
    }

    return (
        <Styled>
            <ProductSelector
                bimClassID={ componentType?.bimClass?.id }
                onChange={ setProduct }
                value={ updatedProduct }
            />
            <UI.Field>
                <UI.FieldLabel>Quantity</UI.FieldLabel>
                <UI.NumberInput
                    onChange={ setQuantity }
                    value={ updatedQuantity ?? "" }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Unit of measurement</UI.FieldLabel>
                <UnitOfMeasurementSelect
                    onChange={ setUOM }
                    value={ updatedUOM ?? "" }
                />
            </UI.Field>
            <Properties
                onChange={ setProperties }
                value={ updatedProperties ?? [] }
            />
            <UI.Button
                $appearance="primary"
                onClick={ onSubmit }
            >
                Save
            </UI.Button>
        </Styled>
    );
}
